module.exports = __webpack_public_path__ + "67146563d7c4ddec5aa4ee7d8cf925f3.svg";